import React from 'react';

const LoadingPage = () => {
  return <div className='page-loading'>
      Loading...
  </div>;
};

export default LoadingPage;
